import React, { useState } from 'react';
import { useGovernance } from '../contexts/GovernanceContext';
import { useWallet } from '../contexts/WalletContext';
import { useNetwork } from '../contexts/NetworkContext';
import { validateGovernanceContract } from '../contracts/contract';
import './ContractAddressInput.css';

const ContractAddressInput: React.FC = () => {
  const { setContractAddress, isValidAddress } = useGovernance();
  const { provider } = useWallet();
  const { currentNetwork } = useNetwork();
  const [address, setAddress] = useState('');
  const [error, setError] = useState('');
  const [isValidating, setIsValidating] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!address.trim()) {
      setError('Please enter a contract address');
      return;
    }

    if (!isValidAddress(address.trim())) {
      setError('Please enter a valid Ethereum address');
      return;
    }

    if (!provider || !currentNetwork) {
      setError('Wallet not connected or network not selected');
      return;
    }

    setIsValidating(true);
    setError('');

    try {
      const isValidContract = await validateGovernanceContract(provider, address.trim());
      
      if (isValidContract) {
        setContractAddress(address.trim());
      } else {
        setError('This address is not a valid Governance contract. Please check the address and try again.');
      }
    } catch (err) {
      setError('Failed to validate contract. Please check your network connection and try again.');
      console.error('Contract validation error:', err);
    } finally {
      setIsValidating(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(e.target.value);
    if (error) setError(''); // Clear error when user starts typing
  };

  return (
    <div className="contract-address-section">
      <div className="contract-address-card">
        <h2>Enter Governance Contract Address</h2>
        <p className="contract-description">
          Please enter the address of the Governance smart contract you want to interact with.
        </p>
        
        <form onSubmit={handleSubmit} className="contract-form">
          <div className="form-group">
            <label htmlFor="contract-address">Contract Address:</label>
            <input
              id="contract-address"
              type="text"
              value={address}
              onChange={handleChange}
              placeholder="0x..."
              className={error ? 'error' : ''}
              autoFocus
            />
            {error && <div className="error">{error}</div>}
          </div>
          
          <button type="submit" className="submit-btn" disabled={isValidating}>
            {isValidating ? 'Validating Contract...' : 'Connect to Governance'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContractAddressInput;
